import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import themeable from 'zignal-landscape/lib/themeable';
import MfeEyeOpenIcon from 'zignal-landscape/lib/Icon/MfeEyeOpenIcon';
import MfeEyeClosedIcon from 'zignal-landscape/lib/Icon/MfeEyeClosedIcon';

const KeywordPill = ({
  id,
  text,
  enabled,
  EnabledIcon,
  DisabledIcon,
  onClick,
  styles
}) => {
  const DisplayIcon = enabled ?
    (EnabledIcon || MfeEyeOpenIcon) :
    (DisabledIcon || MfeEyeClosedIcon);
  const keywordPillStyles = {
    [styles.keywordContainer]: true,
    [styles.disabled]: !enabled
  };
  return (
    <div
      key={id}
      className={classnames(keywordPillStyles)}
      onClick={onClick}
    >
      <span className={styles.keyword}> { text } </span>
      <DisplayIcon className={classnames(styles.baseIcon, styles.icon)} />
    </div>
  );
};

KeywordPill.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  styles: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  EnabledIcon: PropTypes.func,
  DisabledIcon: PropTypes.func,
};

export default themeable(KeywordPill);
